import { type Repub, REPUBS } from '@cx-modules/constants';

import { ODDS_FORMAT, type OddsFormat } from '~/types';

export type Config = {
	betting: boolean;
	canChangeOddsFormat?: boolean;
	login: boolean;
	oddsFormat: OddsFormat;
	offers: boolean;
	search: boolean;
};

class ConfigurationManager {
	private static instance: ConfigurationManager;

	private config: Config;

	public constructor(config: Config) {
		this.config = config;
	}

	static getInstance(currentRepub: Repub): ConfigurationManager {
		if (!ConfigurationManager.instance) {
			const repubConfig: Map<string, Config> = new Map([
				[
					REPUBS.US.name,
					{
						betting: true,
						offers: true,
						login: true,
						search: true,
						canChangeOddsFormat: true,
						oddsFormat: ODDS_FORMAT.AMERICAN,
					},
				],
				[
					REPUBS.XX.name,
					{
						betting: true,
						offers: true,
						login: true,
						search: true,
						canChangeOddsFormat: true,
						oddsFormat: ODDS_FORMAT.DECIMAL,
					},
				],
			]);

			ConfigurationManager.instance = new ConfigurationManager(
				repubConfig.get(currentRepub) || repubConfig.get(REPUBS.XX.name)!,
			);
			// ... any one time initialization goes here ...
		}

		return ConfigurationManager.instance;
	}

	public getConfig(): Config {
		return this.config;
	}
}

export default ConfigurationManager;
